/* =====================================================================
   wl-card.js - Custom element <woo-loop-card>
   Extraido de sections/loop-most-loved.liquid, donde vive inline como
   <loop-product-card>. Se renombra a woo-loop-card para que NUNCA colisione
   con el de la home si ambas secciones coinciden en una pagina.

   La guarda customElements.get() evita una segunda definicion (que lanzaria
   NotSupportedError) si el asset se carga dos veces.
   ===================================================================== */
if (!customElements.get('woo-loop-card')) {
  class WooLoopCard extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.loop-card__swatch');
        if (btn && this.contains(btn)) this.selectSwatch(btn);
      });

      // Respaldo tactil: dentro de un carrusel con scroll-snap el navegador
      // cancela el click si el dedo se desplaza unos pixeles. Escuchamos
      // touchstart/touchend y disparamos la seleccion nosotros cuando el
      // desplazamiento fue minimo (<10px), o sea un tap y no un scroll.
      let tStartX = 0, tStartY = 0, tBtn = null;
      this.addEventListener('touchstart', (e) => {
        const btn = e.target.closest('.loop-card__swatch');
        if (!btn || !this.contains(btn)) { tBtn = null; return; }
        const t = e.changedTouches[0];
        tStartX = t.clientX; tStartY = t.clientY; tBtn = btn;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        if (!tBtn) return;
        const btn = tBtn;
        tBtn = null;
        const t = e.changedTouches[0];
        const moved = Math.hypot(t.clientX - tStartX, t.clientY - tStartY);
        if (moved >= 10) return;
        if (btn.classList.contains('is-active')) return;
        this.selectSwatch(btn);
      }, { passive: true });
    }

    selectSwatch(btn) {
      this.querySelectorAll('.loop-card__swatch').forEach((b) => {
        const active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      const { color, image, price, variantId } = btn.dataset;
      const available = !btn.hasAttribute('data-unavailable');
      const colorName = this.querySelector('[data-color-name]');
      const img       = this.querySelector('.loop-card__img');
      const priceEl   = this.querySelector('[data-price-target]');
      const variantEl = this.querySelector('.product-variant-id');
      const cartBtn   = this.querySelector('[data-cart-btn]');
      if (colorName && color) colorName.textContent = color;
      if (img && image)       { img.removeAttribute('srcset'); img.src = image; }
      if (priceEl && price)   priceEl.textContent = price;
      const cuotaEl = this.querySelector('[data-cuota-target]');
      if (cuotaEl && btn.dataset.cuota) cuotaEl.textContent = btn.dataset.cuota;
      if (variantEl && variantId) {
        variantEl.value = variantId;
        variantEl.disabled = !available;
      }
      if (cartBtn) {
        cartBtn.disabled = !available;
        const label = cartBtn.querySelector('span');
        if (label) label.textContent = available
          ? cartBtn.dataset.addLabel
          : cartBtn.dataset.soldLabel;
      }
    }
  }
  customElements.define('woo-loop-card', WooLoopCard);
}
